<template>

 <v-dialog
    v-model = "dialog"
      :width="width"
      :persistent="pers"
    >
      <!--<template v-slot:activator="{ on }">
        <v-btn
          color="primary"
       
          v-on="on"
        >
          <slot name="trigger-btn">Add</slot>
        </v-btn>
      </template>-->

<v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
        <slot name="modal-title">Title Here</slot>
    </v-card-title>

    <v-card-text>
        <slot name="modal-content">
            Content Here
        </slot>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
        <v-spacer></v-spacer>

        <slot name="modal-actions">

        </slot>
    </v-card-actions>
</v-card>
</v-dialog>

</template>


<script>
    export default {
        props: {
            width:{
                type:String,
                default:'500px'
            }
        },
        data() {
            return {
                dialog: false,
                pers: false
            }
        },
        methods: {
            close() {
                this.dialog = false
            },
            open() {
                this.dialog = true
            },
            IsPersistent() {
                this.pers = true;
            }
        }
    }
</script>